export function createSessionListController({
  sessionListElement, searchInput, tabsElement, documentRef = globalThis.document,
  sessionFacade, sessionStore, messageStore, artifactFacade, runFacade, sessionOpeningController,
  getStatus, setStatus, renderLoading, renderError, renderMessages, updateTokenCounter,
  showRoleCards, showToast, showConfirm,
} = {}) {
  let searchTimer = null;

  async function reload() {
    const keyword = searchInput?.value?.trim() || null;
    renderLoading();
    try {
      await sessionFacade.loadSessions({ status: getStatus(), keyword });
    } catch (error) {
      console.warn('[aichat] loadSessions failed:', error?.message);
      renderError();
    }
  }

  async function handleListClick(event) {
    const retryButton = event.target.closest("[data-action='retry-load-sessions']");
    if (retryButton) return reload();
    const archiveButton = event.target.closest('[data-archive-id]');
    if (archiveButton) {
      const id = Number(archiveButton.dataset.archiveId);
      if (!await showConfirm('归档会话', '确定要归档此会话吗？归档后可在管理后台恢复。')) return;
      const activeSession = sessionStore.getSessionState().currentSession;
      await sessionFacade.archiveSession(id);
      if (activeSession && Number(activeSession.id) === id) {
        sessionFacade.clearCurrentContext();
        messageStore.setMessages([]);
        artifactFacade.artifactStore.clearArtifacts();
        runFacade.runStore.clearRuns();
        renderMessages();
        updateTokenCounter();
        showRoleCards();
      }
      showToast('会话已归档');
      return;
    }
    const item = event.target.closest('[data-session-id]');
    if (item) await sessionOpeningController.openExistingSession(Number(item.dataset.sessionId));
  }

  function handleSearchInput() {
    if (searchTimer) clearTimeout(searchTimer);
    searchTimer = setTimeout(reload, 300);
  }

  function handleTabsClick(event) {
    const tab = event.target.closest('.aichat-session-tab');
    const status = tab?.dataset.status;
    if (!status || status === getStatus()) return;
    setStatus(status);
    documentRef.querySelectorAll('.aichat-session-tab').forEach((item) => item.classList.toggle('active', item.dataset.status === status));
    reload();
  }

  function bind() {
    sessionListElement?.addEventListener('click', handleListClick);
    searchInput?.addEventListener('input', handleSearchInput);
    tabsElement?.addEventListener('click', handleTabsClick);
  }

  return { bind, reload };
}
